import script from "./FreeTutorialComponent1.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeTutorialComponent1.vue?vue&type=script&setup=true&lang=js"

import "./FreeTutorialComponent1.vue?vue&type=style&index=0&id=58cc1adf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58cc1adf"]])

export default __exports__